// eslint-disable-next-line vue/no-parsing-error
import { iasServerHttp, httpClient, metaGen, basicsHttp} from './_http';

const post = (url, payload, opts = {}) =>
httpClient.post(url, payload, {
    baseURL: '/api/customer-server'
});
/**
 * @desc 获取token
 */
export const getToken = (payload = {}) => {
    return httpClient.get('/jwt/token', {
        params: {
            ...payload
        }
    });
};
/**
 * @desc 判断是否同意协议
 */
export const agreementRecord = (payload = {}) => {
    return post('/agreement-record/exist', {
        meta: metaGen()
    });
};

/**
 * @desc 同意协议
 */
export const agreementSave = (payload = {}) => {
    return post('/agreement-record/save', {
        meta: metaGen()
    });
};

/**
 * @desc 个人中心更新 用户信息
 */
export const updateAccountHarbour = (payload = {}) => {
    return httpClient.post('/user/updateAccountHarbour', payload);
};

/**
 * @desc 获取用户是否加入公司信息
 */
export const getUserCompanyStatus = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/getUserCompanyStatus', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 判断公司是否可以加入
 * @param companyName 公司名
 */
export const forCompanyList = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/forCompanyList', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 用户申请加入公司
 * @param companyId 公司名Id
 */
export const applyForCompany = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/applyForCompany', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 用户申请退出公司
 */
export const exitForCompany = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/exitForCompany', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 获取专属打款账号和企业成员
 * @param companyId 公司名Id
 */
export const getCompanyMember = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/getCompanyMember', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 手机号修改
 * @param token 验证码接口token
 * @param code  验证码
 * @param newPhone 新手机号
 */
export const updateMobilePhone = (payload = {}, token) => {
    return post('/user/mobile/update', {
        meta: {
            code: 'HARBOUR',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: {
            ...payload
        }
    }, {
        headers: {
            'Authorization': token
        }
    });
};

/**
 * @desc 获取公司列表
 * @param companyName 公司名
 */
export const getCompany = (payload = {}) => {
    return httpClient.get('/blackMenu/getShouldBlackMenuByName', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 获取公司列表
 * @param name 公司名
 */
export const companySearch = (payload = {}) => {
    return httpClient.get('/duckBill/contract/companySearch/fuzzy', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 获取用户信息
 */
export const getUserInfo = (payload = {}) => {
    return httpClient.get('/duckBill/user/getUserInfo', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 获取企业信息
 */
export const getUserCompanyInfoByName = (payload = {}) => {
    return httpClient.get('/duckBill/user/getUserCompanyInfoByName', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 解绑微信
 */
export const relieveBind = (payload = {}) => {
    return httpClient.get('/wechat/api/relieveBind', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 重置密码
 */
export const validPassword = (payload = {}) => {
    return httpClient.get('/user/valid_password', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 绑定微信
 */
export const bindWechatHttp = (payload = {}) => {
    return httpClient.get('/duckBill/bindWechat', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 获取绑定微信二维码
 */
export const createQRCodeForBinding = (payload = {}) => {
    return httpClient.get('/duckBill/createQRCodeForBinding', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 重置微信二维码
 */
export const wechatResult = (payload = {}) => {
    return httpClient.get('/user/wechatResult', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 询问加入企业或认证企业弹窗 点击确认触发  接口需求 每日只弹一次询问弹窗
 */
export const clickApply = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/clickApply', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 更新公司名
 * @param companyName 公司名
 */
export const updateCompanyMsg = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/updateCompanyMsg', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 获取用户公司名信息
 */
export const getCompanyMsgPlus = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/getCompanyMsgPlus', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 提交企业认证申请 有注册信息
 */
export const verifyCompanyInfo = (payload) => {
    return httpClient.post('/duckBill/verify/companyInfo', payload);
};

/**
 * @desc 获取用户注册信息
 */
export const registrationInfo = (payload = {}) => {
    return httpClient.get('/duckBill/personal/registration/info', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 提交企业认证申请 无注册信息
 */
export const companyInfoForNoRegist = (payload = {}) => {
    return httpClient.post('/duckBill/verify/companyInfoForNoRegist', payload);
};

/**
 * @desc 退出企业功能引导 查询
 */
export const showUserLeadStatus = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/showUserLeadStatus', payload);
};

/**
 * @desc 退出企业功能引导 设置
 */
export const clickLead = (payload = {}) => {
    return httpClient.get('/duckBill/personalManage/clickLead', payload);
};

// 车辆轨迹
export const positionTrack = (payload = {}) => {
    return iasServerHttp.post('/position/track/list', {
        meta: metaGen(),
        params: {
            ...payload
        }
    });
};
/**
 * @desc 获取联系手机号
 */
export const getPhoneNumber = (payload = {}) => {
    return post('/company/contact-phone', {
        meta: {
            code: 'default',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: {
            ...payload
        }
    });
};

// 企业注册
export const companyRegister = (data = {}) => {
    return httpClient.post('/duckBill/application/registration', data);
};

/**
 * @desc 创建企业
 */
export const createCompany = (payload = {}) => {
    return post('/company/wx-register', {
        meta: {
            code: 'default',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: {
            ...payload
        }
    });
};

/**
 * @desc 判断是否已个人实名
 */
export const hasCertification = (payload = {}) => {
    return post('/user/has-certification', {
        meta: {
            code: 'default',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: {
            ...payload
        }
    });
};

export const validateCompany = (data) => {
    return post('/app-register/valid/companyName', {
        meta: {
            code: 'default',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: {
            ...data
        }
    });
};

// 申请人角色
export const characterPosition = (data = {}) => {
    return post('/common/character-position', {
        meta: {
            code: 'default',
            client: 'web',
            tag: 'default',
            time: Date.now()
        },
        params: {
            ...data
        }
    });
};

/**
 * @desc 获取 货车位置查询开关
 */
export const getTruckLock = (payload = {}) => {
    return httpClient.get('/zhiyun/findTruckPositionSwitch/', {
        params: {
            ...payload
        }
    });
};

/**
 * @desc 获取 货车位置查询开关
 */
export const basicData = (data) => {
    return basicsHttp.get(`/query/data/dict/item/${data}`, {});
};


// WEBPACK FOOTER //
// ./src/api/home.js